import { Component, OnInit, ViewChild, ElementRef, ChangeDetectorRef, AfterViewInit, OnDestroy } from '@angular/core';
import { Router, ActivatedRoute } from '@angular/router';
import { LazyLoadEvent, MenuItem } from 'primeng/api';
import { QuestionService } from 'src/app/manage/questionanswer/service/question.service';
import { UserContestService } from 'src/app/services/usercontest.service';
import { ContestService } from 'src/app/services/contest.service';
import { environment } from 'src/environments/environment';
import { TokenStorageService } from 'src/app/services/token-storage.service';
import { ConfirmationService, MessageService } from 'primeng/api';
import { RoleService } from 'src/app/services/role.service';
import { HttpClient } from '@angular/common/http';
import { HeaderComponent } from '../header/header.component';
import { UserService } from 'src/app/services/user.service';
import * as moment from 'moment';
import { Observable, Subscription, interval } from 'rxjs';
@Component({
  selector: 'app-leader-board',
  templateUrl: './contest-leader-board.component.html',
  //changeDetection: ChangeDetectionStrategy.OnPush,
  styleUrls: ['./contest-leader-board.component.scss'],
  providers: [HeaderComponent, MessageService, ConfirmationService],
})
export class ContestLeaderBoardComponent implements OnInit, AfterViewInit, OnDestroy {
  availableClasses: string[] = ["body-dark", "bg-white", ""];
  currentClassIdx: number = 0;
  userResult: boolean = false;
  showContestDetail: boolean = false;
  bodyClass: string;
  items: MenuItem[];
  public options;
  public loading: boolean;
  public errorMessage: string;
  public totalRecords = 0;
  public contestUserList: any[] = [];
  public currentYear: number = new Date().getFullYear();
  carouselResponsiveOptions: any[] = [
    {
      breakpoint: '1024px',
      numVisible: 12,
      numScroll: 12,
      margin: 20,
    },
    {
      breakpoint: '768px',
      numVisible: 2,
      numScroll: 2,
      margin: 20,
    },
    {
      breakpoint: '560px',
      numVisible: 1,
      numScroll: 1
    }
  ];
  @ViewChild('prevButton') prevButton: ElementRef;
  @ViewChild('nextButton') nextButton: ElementRef;
  lazyLoadEvent: LazyLoadEvent;
  public pagination = environment.pagination;
  public mode = "";
  loggedInUser: any;
  isLoggedIn: boolean = false;
  loginRegisterModal: boolean = false;
  showMessage: boolean = false;
  userType;
  userData;
  isLoginFailed: boolean;
  roles;
  trainerRoleId;
  permissions: any[] = [];
  permissionArray: any[] = [];
  userTypeListArray: any[] = [];
  rolelist: any[] = [];
  selectedUserData: any;
  public config = {
    allowNumbersOnly: true,
    length: 6,
    isPasswordInput: false,
    disableAutoFocus: false,
    required: true,
    placeholder: '',
    inputStyles: {
      'width': '50px',
      'height': '50px'
    }
  };
  public userId;
  public contestId: any;
  public showJoinContestMessage: boolean = false;
  public showWaitingTime: boolean = false;
  public matchId;
  public eventStatictics;
  public player1Statistics;
  public contestPoints = {
    'totalPointsWon': 1,
    'numberOfGames': 6,
    'numberOfSetsWon': 50,
    'numberOfAces': 10,
    'breakPointWon': 20
  }
  public matchFinishStatus: boolean = false;
  public selectedUserImage;
  public contestDetails: any = [];
  public playersData;
  intervalTime;
  selectedUserArray: any = [];
  popupmodaltotalpoints;
  playerRanking: any;
  higherlowerranking: any;
  twoToFour: boolean;
  fiveToSeven: boolean;
  sevenToTen: boolean;
  eightToTen: boolean;
  elevenToThirteen: boolean;
  fourteenToEighteen: boolean;
  nineteenToTwentySeven: boolean;
  twentyEightToThirtySix: boolean;
  thirtySevenToFifty: boolean;
  fiftyOnePlus: boolean;
  newContest: boolean;
  isContestDoubles: boolean;
  activeTabIndex:number = 1;
  // public matchId;
  constructor(private questionService: QuestionService,
    private userContestService: UserContestService,
    private contestService: ContestService,
    private router: Router,
    private roleService: RoleService,
    private http: HttpClient,
    private userService: UserService,
    private tokenStorage: TokenStorageService,
    private messageService: MessageService,
    private confirmationService: ConfirmationService,
    private ActiveRoute: ActivatedRoute,
    private elementRef: ElementRef,
    private changeDetectorRef: ChangeDetectorRef,
  ) {
    this.bodyClass = this.availableClasses[this.currentClassIdx];
    this.changeBodyClass();
  }
  ngOnDestroy(): void {
    clearInterval(this.intervalTime);
  }
  async ngAfterViewInit(): Promise<void> {
    // this.interval = interval(10000).subscribe(
    //   (val) => {
    //     this.onClickRefresh();
    //   });
    //await this.getContestDetails()

    // this.intervalTime = setInterval(() => {
    //   this.onClickRefresh();
    // }, 30000);

    if (this.contestDetails?.tournamentMatchStatus !== 'notstarted' && this.contestDetails?.tournamentMatchStatus !== undefined && this.contestDetails?.tournamentMatchStatus !== 'finished') {
      this.intervalTime = setInterval(() => {
        this.onClickRefresh();
      }, 15000);
    }
  }

  onClickViewContest() {
    let currentUrl = '/contest-history/';
    let initialMyContestPaginationvalues = { page: 1, limit: 10, tab: 0 }
    window.localStorage.setItem('my-contest-pagination',JSON.stringify(initialMyContestPaginationvalues));
    this.router.routeReuseStrategy.shouldReuseRoute = () => false;
    this.router.onSameUrlNavigation = 'reload';
    this.router.navigate([currentUrl]);
  }

  changeBodyClass() {
    // get html body element
    const bodyElement = document.body;

    if (bodyElement) {


      this.currentClassIdx = this.getNextClassIdx();
      const nextClass = this.availableClasses[this.currentClassIdx];
      const activeClass = this.availableClasses[this.getPrevClassIdx()];

      // remove existing class (needed if theme is being changed)
      bodyElement.classList.remove(activeClass);
      // add next theme class
      bodyElement.classList.add(nextClass);

      this.bodyClass = nextClass;
    }
  }

  getPrevClassIdx(): number {
    return this.currentClassIdx === 0
      ? this.availableClasses.length - 1
      : this.currentClassIdx - 1;
  }

  getNextClassIdx(): number {
    return this.currentClassIdx === this.availableClasses.length - 1
      ? 0
      : this.currentClassIdx + 1;
  }
  async ngOnInit(): Promise<void> {
    this.loggedInUser = this.tokenStorage.getUser();
    if (this.loggedInUser.userdata != undefined) {
      this.userId = this.loggedInUser.userdata.id;
      this.isLoggedIn = true;
      this.contestId = this.ActiveRoute.snapshot.params.userContestId;
      //this.getUserContest();
    }
    await this.getContestDetails();
    await this.loadContest(this.lazyLoadEvent, 'on-load');

    this.items = [
      { routerLink: "/", label: "Home" },
      { label: "Club Leagues" }
    ];



  }
  async getContestDetails() {
    this.contestService.getContestDetails(this.contestId).subscribe(async res => {
      this.contestDetails = res;
      this.isContestDoubles = (this.contestDetails?.player1Name.split('/').length === 2 && this.contestDetails?.player2Name.split('/').length === 2) ? true : false;
      this.newContest = this.contestDetails?.newContest;
      this.showPrizePoolNewstructure(this.contestDetails);

      this.matchId = this.contestDetails.matchId;
      this.playersData = [
        {
          name: this.contestDetails.player1Name,
          id: this.contestDetails.player1Id,
          playerImage: this.contestDetails.player1Image,
          selected: false
        },
        {
          name: this.contestDetails.player2Name,
          id: this.contestDetails.player2Id,
          playerImage: this.contestDetails.player2Image,
          selected: false
        }
      ];
      this.changeDetectorRef.detectChanges()
      if (this.contestDetails?.tournamentMatchStatus !== 'notstarted' && this.contestDetails?.tournamentMatchStatus !== undefined && this.contestDetails?.tournamentMatchStatus !== 'finished') {
        this.intervalTime = setInterval(() => {
          this.onClickRefresh();
        }, 15000);
      }
      // this.changeDetectorRef.detectChanges();
      //this.showPlayers = true;
    },
      err => {
        console.log(err);
      });
  }
  async loadContest(event: LazyLoadEvent, mode) {
    this.lazyLoadEvent = event;
    let pagenumber = 1;
    let params = "";
    let rows = 10;
    let query = "filterByDisable=false&filterByStatus=true&filterByisContestRegistrationComplete=true&filterByContestId=" + this.contestId;
    if (event !== undefined) {
      if (event.first != undefined && event.first == 0) {
        pagenumber = event.first + 1;
      } else if (event.first != undefined && event.first > 0) {
        pagenumber = (event.first / event.rows) + 1;
      } else {
        pagenumber = 1;
      }
      if (event.rows != undefined) {
        rows = event.rows;
      } else {
        rows = 10;
      }
    }
    query += "&pageSize=" + rows + "&pageNumber=" + pagenumber + params;
    this.userContestService.getUserContestLeaderBoardList(query).subscribe(
      async data => {
        this.loading = false;
        this.contestUserList = [];
        this.selectedUserArray = [];
        this.contestUserList = data.data.items;
        if (this.contestUserList.length > 0) {
          let date = new Date();
          this.totalRecords = data.data.totalCount;
          this.contestUserList.forEach(element => {
            if (this.selectedUserData && this.selectedUserData.userId && this.selectedUserData.userId === element.userId) {
              this.popupmodaltotalpoints = element.totalPoints;
            }
          });
          this.contestUserList.forEach(element => {
            if (this.userId == element.userId) {
              let index = this.findIndexById(this.userId, this.contestUserList);

              if (index != -1) {
                this.selectedUserArray.push(this.contestUserList[index]);
                this.contestUserList.splice(index, 1);
              }
              // this.showJoinContestMessage = true;
            }
            this.matchId = element.matchId;
            if (moment(element.matchDate).isAfter(moment(date))) {
              this.showWaitingTime = false;
            } else {
              this.showWaitingTime = true;
            }
          });
          if (this.selectedUserArray.length > 0) {
            this.contestUserList.unshift(this.selectedUserArray[0]);
          }
          // this.elementRef.nativeElement.querySelector('#joinMsg').style.display = 'none';
        }
        // else {
        //   this.elementRef.nativeElement.querySelector('#joinMsg').style.display = 'block';
        // }

        await this.loadContestForMatchId(this.lazyLoadEvent, mode);
        if (mode === 'on-load' && this.newContest) {
          this.userContestService.updatePoints(this.matchId).subscribe(
            data => { },
            err => { });
          // this.contestUserList.forEach(element => {
          //   if (this.selectedUserData && this.selectedUserData.userId && this.selectedUserData.userId === element.userId) {
          //     this.popupmodaltotalpoints = element.totalPoints;
          //     this.selectedUserData = element;
          //     this.selectedUserImage = this.eventStatictics?.player1Id == this.selectedUserData?.playerId ? element.player1Image : element.player2Image;


          //     this.playerRanking = this.eventStatictics?.player1Id == this.selectedUserData?.playerId ? element.player1Ranking : element.player2Ranking;

          //     this.higherlowerranking =
          //       (this.eventStatictics.player1Id === this.selectedUserData.playerId &&
          //         this.selectedUserData.player1Ranking > this.selectedUserData.player2Ranking) ||
          //         (this.eventStatictics.player2Id === this.selectedUserData.playerId &&
          //           this.selectedUserData.player2Ranking > this.selectedUserData.player1Ranking)
          //         ? this.selectedUserData.headStartPointsForHigherRanking
          //         : this.selectedUserData.headStartPointForLowerRanking;

          //     this.userResult = true;
          //     this.selectedUserData.questionAnswerData.forEach((element) => {
          //       let str = element.question;
          //       let newStr = str.replace("?", "");
          //       element.question = newStr;
          //       if (this.eventStatictics?.player1Id == this.selectedUserData?.playerId) {
          //         if (element.points == 1) {
          //           element.actualPoints = this.eventStatictics.totalPlayerOnePoints * this.contestPoints.totalPointsWon;
          //           element['playerPoints'] = this.eventStatictics.totalPlayerOnePoints;
          //         }
          //         if (element.points == 6) {
          //           element.actualPoints = this.eventStatictics.playerOneTotalGamesWon * this.contestPoints.numberOfGames;
          //           element['playerPoints'] = this.eventStatictics.playerOneTotalGamesWon;
          //         }
          //         if (element.points == 50) {
          //           element.actualPoints = this.eventStatictics.playerOneSetsWon * this.contestPoints.numberOfSetsWon;
          //           element['playerPoints'] = this.eventStatictics.playerOneSetsWon;
          //         }
          //         if (element.points == 10) {
          //           element.actualPoints = this.eventStatictics.playerOneAces * this.contestPoints.numberOfAces;
          //           element['playerPoints'] = this.eventStatictics.playerOneAces;
          //         }
          //         if (element.points == 20) {
          //           element.actualPoints = this.eventStatictics.playerOneTotalBreakPoints * this.contestPoints.breakPointWon;
          //           element['playerPoints'] = this.eventStatictics.playerOneTotalBreakPoints;
          //         }
          //         //element.playerImage = user.player1Image
          //       }

          //       //player2
          //       if (this.eventStatictics?.player2Id == this.selectedUserData?.playerId) {
          //         if (element.points == 1) {
          //           element.actualPoints = this.eventStatictics.totalPlayerTwoPoints * this.contestPoints.totalPointsWon;
          //           element['playerPoints'] = this.eventStatictics.totalPlayerTwoPoints;
          //         }
          //         if (element.points == 6) {
          //           element.actualPoints = this.eventStatictics.playerTwoTotalGamesWon * this.contestPoints.numberOfGames;
          //           element['playerPoints'] = this.eventStatictics.playerTwoTotalGamesWon;
          //         }
          //         if (element.points == 50) {
          //           element.actualPoints = this.eventStatictics.playerTwoSetsWon * this.contestPoints.numberOfSetsWon;
          //           element['playerPoints'] = this.eventStatictics.playerTwoSetsWon;
          //         }
          //         if (element.points == 10) {
          //           element.actualPoints = this.eventStatictics.playerTwoAces * this.contestPoints.numberOfAces;
          //           element['playerPoints'] = this.eventStatictics.playerTwoAces;
          //         }
          //         if (element.points == 20) {
          //           element.actualPoints = this.eventStatictics.playerTwoTotalBreakPoints * this.contestPoints.breakPointWon;
          //           element['playerPoints'] = this.eventStatictics.playerTwoTotalBreakPoints;
          //         }
          //         //element.playerImage = user.player2Image
          //       }
          //     })
          //   }
          // });
          // await this.leaderboardModal(this.selectedUserData, mode)
          // this.onClickRefresh();
        }
      },
      err => {
        this.errorMessage = err.error.message;
      });
  }
  findIndexById(id, arrayName) {
    let index = -1;
    for (let i = 0; i < arrayName.length; i++) {
      if (arrayName[i].userId === id) {
        index = i;
        break;
      }
    }
    return index;
  }

  onClickRefresh() {
    this.userContestService.updatePoints(this.matchId).subscribe(
      data => {
        this.loadContest(this.lazyLoadEvent, 'on-refresh');
        this.loadContestForMatchId(this.lazyLoadEvent, 'on-refresh');
        // if (this.selectedUserData !== undefined) {
        //   this.leaderboardModal(this.selectedUserData,'on-refresh');
        // }
      },
      err => {

      }
    )
  }

  async leaderboardModal(user: any, mode) {
    this.contestUserList.forEach(element => {
      if (user && user.userId && user.userId === element.userId) {
        this.popupmodaltotalpoints = element.totalPoints;
        this.selectedUserData = user;
        this.selectedUserImage = this.eventStatictics?.player1Id == this.selectedUserData?.playerId ? user.player1Image : user.player2Image;
        this.playerRanking = this.eventStatictics?.player1Id == this.selectedUserData?.playerId ? user.player1Ranking : user.player2Ranking;

        this.higherlowerranking =
          (this.eventStatictics.player1Id === this.selectedUserData.playerId &&
            this.selectedUserData.player1Ranking > this.selectedUserData.player2Ranking) ||
            (this.eventStatictics.player2Id === this.selectedUserData.playerId &&
              this.selectedUserData.player2Ranking > this.selectedUserData.player1Ranking)
            ? this.selectedUserData.headStartPointsForHigherRanking
            : this.selectedUserData.headStartPointForLowerRanking;

        if(user?.newContest) {
          this.router.navigate(['/user-contest-leader-board/'+user.contestId+'/'+user.userId]);
        } else {
          this.userResult = true;
        }
        this.selectedUserData.questionAnswerData.forEach((element) => {
          let str = element.question;
          let newStr = str.replace("?", "");
          element.question = newStr;
          if (this.eventStatictics?.player1Id == this.selectedUserData?.playerId) {
            if (element.points == 1) {
              element.actualPoints = this.eventStatictics.totalPlayerOnePoints * this.contestPoints.totalPointsWon;
              element['playerPoints'] = this.eventStatictics.totalPlayerOnePoints;
            }
            if (element.points == 6) {
              element.actualPoints = this.eventStatictics.playerOneTotalGamesWon * this.contestPoints.numberOfGames;
              element['playerPoints'] = this.eventStatictics.playerOneTotalGamesWon;
            }
            if (element.points == 50) {
              element.actualPoints = this.eventStatictics.playerOneSetsWon * this.contestPoints.numberOfSetsWon;
              element['playerPoints'] = this.eventStatictics.playerOneSetsWon;
            }
            if (element.points == 15) {
              element.actualPoints = this.eventStatictics.playerOneAces * this.contestPoints.numberOfAces;
              element['playerPoints'] = this.eventStatictics.playerOneAces;
            }
            if (element.points == 20) {
              element.actualPoints = this.eventStatictics.playerOneTotalBreakPoints * this.contestPoints.breakPointWon;
              element['playerPoints'] = this.eventStatictics.playerOneTotalBreakPoints;
            }
            //element.playerImage = user.player1Image
          }

          //player2
          if (this.eventStatictics?.player2Id == this.selectedUserData?.playerId) {
            if (element.points == 1) {
              element.actualPoints = this.eventStatictics.totalPlayerTwoPoints * this.contestPoints.totalPointsWon;
              element['playerPoints'] = this.eventStatictics.totalPlayerTwoPoints;
            }
            if (element.points == 6) {
              element.actualPoints = this.eventStatictics.playerTwoTotalGamesWon * this.contestPoints.numberOfGames;
              element['playerPoints'] = this.eventStatictics.playerTwoTotalGamesWon;
            }
            if (element.points == 50) {
              element.actualPoints = this.eventStatictics.playerTwoSetsWon * this.contestPoints.numberOfSetsWon;
              element['playerPoints'] = this.eventStatictics.playerTwoSetsWon;
            }
            if (element.points == 15) {
              element.actualPoints = this.eventStatictics.playerTwoAces * this.contestPoints.numberOfAces;
              element['playerPoints'] = this.eventStatictics.playerTwoAces;
            }
            if (element.points == 20) {
              element.actualPoints = this.eventStatictics.playerTwoTotalBreakPoints * this.contestPoints.breakPointWon;
              element['playerPoints'] = this.eventStatictics.playerTwoTotalBreakPoints;
            }
            //element.playerImage = user.player2Image
          }
        })
      }
    });
  }

  contestPlayerName(playerName) {
    if (playerName.split('/').length !== 2) {
      playerName = playerName.split(' ').filter(ele => ele.length > 2)[0];
    } else {
      playerName = playerName.split('/')[0].split(' ')[0]+' & '+playerName.split('/')[1].split(' ')[1];
    }
    return playerName;
  }

  showPointModal() {
    this.showContestDetail = true;
  }
  closeContestModal() {
    this.showContestDetail = false;
  }


  async loadContestForMatchId(event: LazyLoadEvent, mode) {
    this.lazyLoadEvent = event;
    let pagenumber = 1;
    let params = "";
    let rows = 10;
    let query = "filterByDisable=false&filterByStatus=true&filterByMatchId=" + this.matchId;

    query += "&pageSize=" + rows + "&pageNumber=" + pagenumber + params;
    this.userContestService.getEventStatistics(query).subscribe(
      (data: any) => {
        this.eventStatictics = data.data.items[0];
        this.matchFinishStatus = this.eventStatictics?.matchFinishStatus;
        if (this.selectedUserData !== undefined) {
          this.selectedUserData.questionAnswerData.forEach((element) => {
            let str = element.question;
            let newStr = str.replace("?", "");
            element.question = newStr;
            if (this.eventStatictics?.player1Id == this.selectedUserData?.playerId) {
              if (element.points == 1) {
                element.actualPoints = this.eventStatictics.totalPlayerOnePoints * this.contestPoints.totalPointsWon;
                element['playerPoints'] = this.eventStatictics.totalPlayerOnePoints;
              }
              if (element.points == 6) {
                element.actualPoints = this.eventStatictics.playerOneTotalGamesWon * this.contestPoints.numberOfGames;
                element['playerPoints'] = this.eventStatictics.playerOneTotalGamesWon;
              }
              if (element.points == 50) {
                element.actualPoints = this.eventStatictics.playerOneSetsWon * this.contestPoints.numberOfSetsWon;
                element['playerPoints'] = this.eventStatictics.playerOneSetsWon;
              }
              if (element.points == 15) {
                element.actualPoints = this.eventStatictics.playerOneAces * this.contestPoints.numberOfAces;
                element['playerPoints'] = this.eventStatictics.playerOneAces;
              }
              if (element.points == 20) {
                element.actualPoints = this.eventStatictics.playerOneTotalBreakPoints * this.contestPoints.breakPointWon;
                element['playerPoints'] = this.eventStatictics.playerOneTotalBreakPoints;
              }
              //element.playerImage = user.player1Image
            }

            //player2
            if (this.eventStatictics?.player2Id == this.selectedUserData?.playerId) {
              if (element.points == 1) {
                element.actualPoints = this.eventStatictics.totalPlayerTwoPoints * this.contestPoints.totalPointsWon;
                element['playerPoints'] = this.eventStatictics.totalPlayerTwoPoints;
              }
              if (element.points == 6) {
                element.actualPoints = this.eventStatictics.playerTwoTotalGamesWon * this.contestPoints.numberOfGames;
                element['playerPoints'] = this.eventStatictics.playerTwoTotalGamesWon;
              }
              if (element.points == 50) {
                element.actualPoints = this.eventStatictics.playerTwoSetsWon * this.contestPoints.numberOfSetsWon;
                element['playerPoints'] = this.eventStatictics.playerTwoSetsWon;
              }
              if (element.points == 15) {
                element.actualPoints = this.eventStatictics.playerTwoAces * this.contestPoints.numberOfAces;
                element['playerPoints'] = this.eventStatictics.playerTwoAces;
              }
              if (element.points == 20) {
                element.actualPoints = this.eventStatictics.playerTwoTotalBreakPoints * this.contestPoints.breakPointWon;
                element['playerPoints'] = this.eventStatictics.playerTwoTotalBreakPoints;
              }
              //element.playerImage = user.player2Image
            }
          })
        }

      },

      err => {
        this.errorMessage = err.error.message;
      });
  }
  async onClickMatchStats(matchId) {
    this.router.navigate(['contest-match-stats/' + matchId]);
  }

  showPrizePoolNewstructure(contest) {
      this.twoToFour = (contest.totalEntries >= 0 && contest.totalEntries <= 4) ? true : false;
      this.fiveToSeven = (contest.totalEntries >= 5 && contest.totalEntries <= 7) ? true : false;
      this.sevenToTen = false;
      this.eightToTen = (contest.totalEntries >= 8 && contest.totalEntries <= 10) ? true : false;
      this.elevenToThirteen = (contest.totalEntries >= 11 && contest.totalEntries <= 13) ? true : false;
      this.fourteenToEighteen = (contest.totalEntries >= 14 && contest.totalEntries <= 18) ? true : false;
      this.nineteenToTwentySeven = (contest.totalEntries >= 19 && contest.totalEntries <= 27) ? true : false;
      this.twentyEightToThirtySix = (contest.totalEntries >= 28 && contest.totalEntries <= 36) ? true : false;
      this.thirtySevenToFifty = (contest.totalEntries >= 37 && contest.totalEntries <= 50) ? true : false;
      this.fiftyOnePlus = (contest.totalEntries >= 51) ? true : false;
  }



}